<p-dialog class="pettyCashDialog" [style]="{width: '400px'}" [header]='setLabel("addPettyExpenseHeaderLabel")'
    [(visible)]="pettydialogVisibility" (onHide)="onBeforeDialogHide()">
    <div class="payout-main-wrapper">
        <div class="payout-fields">
            <label>{{setLabel("paymentModeLabel")}}</label>
            <p-dropdown [options]="paymentOptions" (onChange)="onPaymentModeChange($event.value)"></p-dropdown>
        </div>
        <div class="payout-fields">
            <label>{{setLabel("amountLabel")}}</label>
            <input type="number" min="0" pInputText name="pettyExpenseTpe" [(ngModel)]="amount" />
        </div>

        <div class="payout-fields">
                <label>{{setLabel("dateLabel")}}</label>
                <input type="date" name="expenseDate" [max]="currentDate" [(ngModel)]="expenseDate" />
        </div>

        <div class="payout-fields">
            <label>{{setLabel("expenseTypeLabel")}}</label>
            <p-dropdown [(ngModel)]="expenseType" [options]="expenseTypeOptions"
                (onChange)="expenseTypeDropdownChange($event)"></p-dropdown>
        </div>
        <div *ngIf="expenseType === 'Lending' || expenseType === 'Account Deducted'" class="payout-fields">
            <Label *ngIf="expenseType === 'Lending'">{{setLabel("borrowerNameLabel")}}</Label>
            <Label *ngIf="expenseType === 'Account Deducted'">{{setLabel("accountHolderNameLabel")}}</Label>
            <p-dropdown name="Borrower Name" [options]="userOptions" [(ngModel)]="selectedUser"
                (onChange)="dropdownChange($event)"></p-dropdown>
        </div>
        <div *ngIf="expenseType === 'Salary'" class="payout-fields">
            <Label>{{setLabel("userNameLabel")}}</Label>
            <p-dropdown name="User Name" [options]="userOptions" [(ngModel)]="selectedUser"
                (onChange)="dropdownChange($event)"></p-dropdown>
        </div>
        <div *ngIf="expenseType === 'Purchasing'" class="payout-fields">

            <Label>{{setLabel("productNameLabel")}}</Label>
            <select style="width: 100%; height: 2em; border: 1px solid darkgrey; background-image: none;" type="text" pInputText name="Purchased Item"
                [(ngModel)]="purchasedItem">
                <option value="" disabled selected>{{setLabel("selectProductPlaceholder")}}</option>
                <optgroup label="Stationary Item">
                    <option value="Pen">{{setLabel("penLabel")}}</option>
                    <option value="Pencel">{{setLabel("pencelLabel")}}</option>
                    <option value="Eraser">{{setLabel("eraserLabel")}}</option>
                    <option value="Scale">{{setLabel("scaleLabel")}}</option>
                    <option value="Steppler">{{setLabel("stepplerLabel")}}</option>
                    <option value="Steppler Pins">{{setLabel("stepplerPinsLabel")}}</option>
                    <option value="Paper Holding Pins">{{setLabel("paperHoldingPinsLabel")}}</option>
                </optgroup>
                <optgroup label="Foods">

                    <option value="Pizza">{{setLabel("pizzaLabel")}}</option>
                    <option value="Burger">{{setLabel("burgerLabel")}}</option>
                    <option value="Pasta">{{setLabel("pastaLabel")}}</option>
                    <option value="Biryani">{{setLabel("biryaniLabel")}}</option>
                    <option value="Pulao">{{setLabel("pulaoLabel")}}</option>
                    <option value="Desi Food">{{setLabel("desiFoodLabel")}}</option>

                </optgroup>
                <optgroup label="Tea">

                    <option value="Coffee">{{setLabel("coffeeLabel")}}</option>
                    <option value="Green Tea">{{setLabel("greenTeaLabel")}}</option>
                    <option value="Tea">{{setLabel("teaLabel")}}</option>

                </optgroup>

                <optgroup label="Drinks">

                    <option value="Minarl Water">{{setLabel("mineralWaterLabel")}}</option>
                    <option value="Juice">{{setLabel("juiceLabel")}}</option>
                    <option value="Cold Drinks">{{setLabel("coldDrinksLabel")}}</option>
                    <option value="Energy Drinks">{{setLabel("energyDrinksLabel")}}</option>

                </optgroup>

                <optgroup label="Others">

                    <option value="Air freshner">{{setLabel("airFreshnerLabel")}}</option>
                    <option value="Print Paper">{{setLabel("printPaperLabel")}}</option>
                    <option value="Equipment Part">{{setLabel("equipmentPartLabel")}}</option>

                </optgroup>
            </select>
        </div>
        <div *ngIf="expenseType === 'Bills'" class="payout-fields">

            <Label>{{setLabel("billTypeLabel")}}</Label>
            <select style="width: 100%; height: 2em; border: 1px solid darkgrey; background-image: none;" type="text" pInputText name="Bill Type" [(ngModel)]="billType">

                <option value="Electricity">{{setLabel("electricityLabel")}}</option>
                <option value="Internet">{{setLabel("internetLabel")}}</option>
                <option value="Maintenance">{{setLabel("maintenanceLabel")}}</option>
                <option value="Repairing">{{setLabel("repairingLabel")}}</option>
                <option value="Water Bottles">{{setLabel("waterBottlesLabel")}}</option>
                <option value="Other">{{setLabel("otherLabel")}}</option>
            </select>

        </div>

        <div class="payout-fields">

            <span>{{setLabel("commentLabel")}}</span>

        </div>
        <div class="payout-fields">
            <textarea rows="5" [(ngModel)]="description" name="description"></textarea>
        </div>


        <div class="payout-fields">
            <button class="p-button-success" pButton
                (click)="addPettyExpense()">{{setLabel("addExpenseLabel")}}</button>
        </div>
    </div>
</p-dialog>